import type { ReactNode } from "react";

export function StatusBadge({ tone, children }: { tone: "success" | "warning" | "danger" | "neutral" | "info"; children: ReactNode }) {
  return <span className={`status-badge status-${tone}`}>{children}</span>;
}

export function statusTone(status: string): "success" | "warning" | "danger" | "neutral" | "info" {
  if (["shipped", "delivered", "success", "connected", "active"].includes(status)) return "success";
  if (["pending_payment", "pending_shipment", "partial", "needs_auth"].includes(status)) return "warning";
  if (["failed", "refunded", "error"].includes(status)) return "danger";
  if (["running", "info"].includes(status)) return "info";
  return "neutral";
}
